import BulkAssignContainer from './BulkAssignContainer'

export default BulkAssignContainer
